/**
 * List of different page states and actions of interest.
 *
 * To be used as New Relic page action events.
 * @alpha
 */
var PageAction;
(function (PageAction) {
    PageAction["FrameworkReady"] = "pubhub-framework-ready";
    PageAction["SdkReady"] = "pubhub-sdk-ready";
    PageAction["ChannelDataReady"] = "pubhub-channel-data-ready";
    PageAction["AssetsReady"] = "pubhub-assets-ready";
    PageAction["ChannelReady"] = "pubhub-channel-ready";
})(PageAction || (PageAction = {}));

export { PageAction };
//# sourceMappingURL=page-actions.mjs.map
